// Fetch list

export const FETCH = 'reportDriverHourlyOverview.FETCH'
export const FETCH_STARTED = 'reportDriverHourlyOverview.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportDriverHourlyOverview.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportDriverHourlyOverview.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportDriverHourlyOverview.FETCH_CANCELLED'

// Clear

export const CLEAR = 'reportDriverHourlyOverview.CLEAR'

// Export

export const EXPORT = 'reportDriverHourlyOverview.EXPORT'
export const EXPORT_FULFILLED = 'reportDriverHourlyOverview.EXPORT_FULFILLED'

// Fetch details

export const FETCH_DETAILS = 'reportDriverHourlyOverview.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportDriverHourlyOverview.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportDriverHourlyOverview.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportDriverHourlyOverview.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportDriverHourlyOverview.FETCH_DETAILS_CANCELLED'

// Clear details

export const CLEAR_DETAILS = 'reportDriverHourlyOverview.CLEAR_DETAILS'

// Export details

export const EXPORT_DETAILS = 'reportDriverHourlyOverview.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportDriverHourlyOverview.EXPORT_DETAILS_FULFILLED'